// extracted by mini-css-extract-plugin
module.exports = {"actions":"handshake_actions__B1Kmz","accept":"handshake_accept__3s1zU","reject":"handshake_reject__3KXT1","hide":"handshake_hide__2qEne","exitBtn":"handshake_exitBtn__2Youc"};